import styled from "styled-components"

import padding from "@irati/ui/src/global/padding"

const Card = styled.div`
  background: ${({theme}) => theme.colors.greys.white};
  border: 1px solid ${({theme}) => theme.colors.greys.light};
  padding: ${padding.base};
`

export default Card
